// extracted by mini-css-extract-plugin
module.exports = {"component":"Map_component__2O8N6"};